import React, { useState, useEffect } from "react";
import SimpleFilter from "../../components/Filter/SimpleFilter";
import ActionDialog from "../../components/Dialogs/ActionDialog";
import { FormDialog } from "../../components/FormDialog/FormDialog";
import { fetchAPIData, generateHiddenColumns, allPermissionOptions,createFilterOptions, createSortFieldOptions } from '../../Utils/Common';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import './system.scss';

const dbUpdateSchema = require("../../json/dbUpdateSchema.json").view;

const SystemDbUpdateTabPanel = ({ setNotify }) => {

    const [apiData, setApiData] = useState({});
    const [rowJsonData, setRowJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [reload, setReload] = useState(false);
    const [isLoading, setIsloading] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const [dbUpdate, setDbUpdate] = usePersistentStorage("dbUpdate", []);

    useEffect(() => {
        setApiData(dbUpdate);
    }, []);

    const fieldData = [
        'createdDate', 'createdUserId', 'scriptName', 'dbName'
    ];

    const sortFieldData = [
        {
            field: 'createdDate',
            label: 'Updated Date'
        },
        {
            field: 'scriptName',
            label: 'Script Name'
        },
        {
            field: 'dbName',
            label: 'DB'
        },
        {
            field: 'createdUserId',
            label: 'Updated By'
        }
    ];

    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            hideable: false,
            field: 'createdDate',
            headerName: 'Update Date',
            type: 'date',
            minWidth: 300,
            maxWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            hideable: false,
            field: 'scriptName',
            headerName: 'Script Name',
            renderCell: renderCellExpand,
            minWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable: false,
            field: 'dbName',
            headerName: 'DB',
            renderCell: renderCellExpand,
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable: false,
            field: 'createdUserId',
            headerName: 'Updated By',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        }
    ];

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setRowJsonData(JsonData);
        setMode('view');
        setOpen(true);
    };

    const fetchData = async (apiURL2) => {
        setIsloading(true);
        await fetchAPIData(apiURL2)
            .then((data) => {
                setApiData(data);
                setDbUpdate(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load db update data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                setReload(false);
                setIsloading(false);
            });

    }

    return (
        <>
            <div id="filterContainer" >
                <SimpleFilter permission={allPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL='/api/dbupdates?' fetchData={fetchData} useCompanyId={false} reload={reload} />
            </div>

            <div id="dbUpdateContainer">
                <div >
                    <Table data={apiData} columns={columns} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>

            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                title="DP Update Information"
                defaultTab='JSON'
                propertiesTabContent={
                    <FormDialog
                        formId={'dbUpdateReportsDialogId'}
                        readOnly={true}
                        schema={dbUpdateSchema}
                        formData={rowJsonData}
                    />
                }
                jsonDataName="DB Update Reports"
                JSONTabContent={rowJsonData}
            />

        </>
    );
}

export default SystemDbUpdateTabPanel;